import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
import { Icon } from "../../../Icon";
export const lionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  .copy-to-clipboard_item {
    color: ${chroma.input.foreground};
    background-color: ${paletteTokens.bladebg2};

    span {
      padding-left: 8px;
    }
  }

  .copy-to-clipboard_success {
    color: ${paletteTokens.bladebg2};
    ${chroma.typography.body3}

    ${Icon} {
      background-color: ${paletteTokens.bladetext2};
      flex-shrink: 0;
    }

    span {
      padding-left: 4px;
    }
  }
`;
//# sourceMappingURL=index.js.map